import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWC512F1 (計畫生產通知單核准)
// ============================================================

export interface ApprovalCandidate {
  fc210_01: string; // 計畫生產通知單號（主鍵）
  fc210_12: string; // 下單客戶名稱
  fc210_13: string; // 成衣買主名稱
  fc210_14: string; // 業務員名稱
  fc210_19: string; // 驗貨完成日
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwc512Api = {
  /** Query production plan notice candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwc512/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected production plan notices */
  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwc512/approve', { items });
    return res.data;
  },
};
